/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Gate_Desc_Api_Keys_PersonalInputs */



/**
* | output |
* | --- |
* | "Generate personal API keys for programmatic access." |
*
* @param {Plan_Gate_Desc_Api_Keys_PersonalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_gate_desc_api_keys_personal = /** @type {((inputs?: Plan_Gate_Desc_Api_Keys_PersonalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Gate_Desc_Api_Keys_PersonalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstellen Sie persönliche API-Schlüssel für den programmatischen Zugriff.")
	return /** @type {LocalizedString} */ ("Generate personal API keys for programmatic access.")
});